module.exports = __webpack_public_path__ + "img/circle-error.42157a5e.svg";